import { useIbanXSBanksRecipientsPivotActions } from "features/openBanking/actions";
import { useOpenBankingResource } from "../shared/OpenBankingResource";

export default function useIbanXSBanksRecipientsPivot() {
    const { onRowClick } = useOpenBankingResource();

    const {
        getIbanXSBanksRecipientsPivot: getResource,
        downloadCsv
    } = useIbanXSBanksRecipientsPivotActions();

    return {
        downloadCsv,
        getResource,
        onRowClick
    };
};
